import { FactoryProvider } from '@angular/core';
import { Router } from '@angular/router';

import { OKTA_CONFIG, OktaAuthService } from '@okta/okta-angular';

import { AppSettingsService } from './app-settings.service';

export function onAuthRequired(_oktaAuth: OktaAuthService, router: Router) {
  router.navigate(['/']);
}

export function oktaConfigFactory(appSettingsService: AppSettingsService) {
  const config = appSettingsService.getSettings();

  const oktaConfig = {
    ...config.oktaConfiguration,
    onAuthRequired,
  };

  return oktaConfig;
}

export const OktaConfigProvider: FactoryProvider = {
  provide: OKTA_CONFIG,
  useFactory: oktaConfigFactory,
  deps: [AppSettingsService],
};
